export default {
	title: "Getting Started",
	items: [
		{
			id: "first-steps:onboardingCall",
			title: "📆 Schedule Onboarding Call",
			info: "https://calendly.com/jonas08/onboarding-call-1"
		},
		{
			id: "first-steps:theLoanerPlaybook",
			title: "🤝 Use the loaner playbook to borrow a minimum of 6-8 listings",
			info: "/playbooks?highlight=theLoanerPlaybook",
			videoUrl: "https://www.loom.com/share/17fc136572d24803b4c53525aed2ba11?sid=82d7c4a4-a946-40e8-8c8b-beb65e5c88a4"
		},
		{
			id: "first-steps:import3Listings",
			title: "⬆️ Import 3 listings",
			info: "/listing?tutorial=importListing",
			videoUrl: "https://www.loom.com/share/d34a3595e9044294b556e655d1111be9?sid=7090ac43-2598-4c9c-b7e7-0ad0e45bc4ba",
		},
		{
			id: "first-steps:create3CraigslistAds",
			title: "✨Create 3 Craigslist ads with PPT ",
			info: "/ads?tutorial=importClAd",
			videoUrl: "https://www.loom.com/share/1bbf826825fe4d25bca75feb3ab134b9?sid=0eda23e6-d67d-4634-a524-8209ef4bc2fb",
		},
		{
			id: "first-steps:post3CraigslistAds",
			title: "📣☮️ Post 3 ads to Craigslist",
			videoUrl: "https://www.loom.com/share/405619dd7afd4e93899e0310d7b05eda?sid=ceed5f16-3458-4341-b0d1-a6bf1fb62fcc"
		},
		{
			id: "first-steps:craigslistAdReview",
			title: "Submit Craigslist ad for review",
		},
		{
			id: "first-steps:create3FbAds",
			title: "✨Create 3 Facebook ads with PPT ",
			info: "/ads?tutorial=importFbAd",
			videoUrl: "https://www.loom.com/share/1e8baab3c9aa4b8eafce8b798c535235?sid=de102d0b-cd92-4377-b583-659eb27a6881"
		},
		{
			id: "first-steps:post3FbAds",
			title: "📣 Post 3 ads to Facebook Marketplace",
			videoUrl: "https://www.loom.com/share/1e8baab3c9aa4b8eafce8b798c535235?sid=de102d0b-cd92-4377-b583-659eb27a6881"
		},
		{
			id: "first-steps:fbAdReview",
			title: "Submit FB Marketplace ads for review",
		},
		{
			id: "first-steps:lead",
			title: "📧 Email or text your coach with first lead (Big win #1!)",
		},
		{
			id: "first-steps:joinPowerLunchGroup",
			title: "Join Power Lunch Facebook Group (Wednesdays at 2pm ET)",
			info: "https://www.facebook.com/groups/powerlunchrealestate"
		}
	],
	id: "first-page"
}